var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition-loader",class:{ fullPage: _vm.fullPage }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition-loader-inner"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }